module.exports = __webpack_public_path__ + "static/img/3.88ac196.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/3.png
// module id = dCwG
// module chunks = 0